import type { Key } from 'react'
import type { Dayjs } from 'dayjs'
import dayjs from 'dayjs'
import type { AdvancedQueryPayload } from '../pages/DataVisualization/savedFilterSchemes'

/** 与资产数据列表行结构一致（避免与页面循环依赖） */
export type CachedDataRow = {
  key: string
  id: string
  name: string
  source: string
  type: string
  documentStatus: string
  onChain: string
  contractNo: string
  contractType: string
  customer: string
  settlementOrg: string
  productName: string
  priceTaxTotal: number | null
  receiptAmount: number | null
  partialReceipt: string
  unreceivedAmount: number | null
  invoicedAmount: number | null
  contractCreatedDate: string
  contractReceiptDate: string
  value: number | null
  status: string
  createdTime: string
  ordernumber: string
  bill_no: string
  onChainListed: boolean
  contractAttachment?: string
  orderAttachment?: string
  receiptAttachment?: string
  logisticsAttachment?: string
  invoiceAttachment?: string
}

const CACHE_KEY = 'asset_data_list_state_v1'
const MAX_AGE_MS = 30 * 60 * 1000

export type DataListCachePayload = {
  tableData: CachedDataRow[]
  listTotal: number
  listPage: number
  listPageSize: number
  selectedRowKeys: Key[]
  appliedAssetType: string
  appliedAssetStatus: string
  appliedKeyword: string
  appliedSource: string
  appliedCustomer: string
  appliedSettlementOrg: string
  appliedContractMin: number | null
  appliedContractMax: number | null
  appliedContractCreatedRange: [string | null, string | null] | null
  appliedReceiptDateRange: [string | null, string | null] | null
  appliedDateRange: [string | null, string | null] | null
  appliedAdvancedQuery: AdvancedQueryPayload
  summaryStats: {
    totalValue: number
    totalUnreceivedAmount: number
    availableValue: number
    totalCount: number
    availableCount: number
  } | null
  ts: number
}

export function saveDataListCache(payload: Omit<DataListCachePayload, 'ts'>): void {
  try {
    sessionStorage.setItem(CACHE_KEY, JSON.stringify({ ...payload, ts: Date.now() }))
  } catch {
    /* ignore quota */
  }
}

export function loadDataListCache(): DataListCachePayload | null {
  try {
    const raw = sessionStorage.getItem(CACHE_KEY)
    if (!raw) return null
    const parsed = JSON.parse(raw) as DataListCachePayload
    if (!parsed?.ts || Date.now() - parsed.ts > MAX_AGE_MS) {
      sessionStorage.removeItem(CACHE_KEY)
      return null
    }
    return parsed
  } catch {
    return null
  }
}

export function parseCachedDayRange(t: [string | null, string | null] | null): [Dayjs | null, Dayjs | null] | null {
  if (!t?.[0] || !t?.[1]) return null
  const a = dayjs(t[0])
  const b = dayjs(t[1])
  return a.isValid() && b.isValid() ? [a, b] : null
}
